import { Stack, Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useOutletContext, useSearchParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { SelectedVideoCard } from '../components/SelectedVideoCard'
import { VideosContainer } from '../components/VideosContainer'
import { IVideo, useFetchVideos } from '../hooks/useFetchVideos'
import { LoadMoreBtn } from '../../../../components/Loader'
import { ConfirmationDialog } from '../../../../components/ConfirmationDialog/ConfirmationDialog'

export function VideoUGC() {
  const [searchParams, setSearchParams] = useSearchParams();
  // @ts-ignore
  const [,,, setCount] = useOutletContext();
  const [videoId, setVideoId] = useState<number | null>(null);
  const [deleteVideoIndex, setDeleteVideoIndex] = useState<number | null>(null);
  const {
    loading,
    videos,
    setVideos,
    error,
    deleteUGC,
    fetchVideos,
    total,
    loadMore,
  } = useFetchVideos("UGC");

  useEffect(() => {
    const video = searchParams.get("video");
    if (video) {
      const id = parseInt(video, 10) || 0;
      if (id) setVideoId(id);
    }
  }, [searchParams]);

  useEffect(() => {
    if (total) setCount(total);
  }, [total]);

  const handleDeleteVideo = (i: number) => {
    setDeleteVideoIndex(i);
  };

  const confirmDeleteVideo = async () => {
    const i = deleteVideoIndex;
    setDeleteVideoIndex(null);
    if (i !== null && videos) {
      const reviewId = videos[i].id;
      try {
        await deleteUGC(reviewId);
        setVideos((oldValues) => oldValues?.filter((val, ii) => i !== ii));
        toast.success("Video Deleted");
        setVideoId(null);
      } catch (e) {
        toast.success("Video Not Deleted");
      }
    }
  };

  const handleSelectVideo = (video: IVideo) => {
    setVideoId(video.id);
    //updateVideoId(video.id);
  };

  const handleResetVideo = () => {
    searchParams.delete("selectedTab");
    setSearchParams();
    setVideoId(null);
    //updateVideoId(null);
  };

  return (
    <Stack direction="row" alignItems="top">
      {videoId ? (
        <Box flexGrow={1}>
          <SelectedVideoCard
            videoId={videoId}
            onClose={() => handleResetVideo()}
            type="review"
            refetch={fetchVideos}
          />
        </Box>
      ) : (
        <Box
          height={videoId !== null ? "77vh" : "auto"}
          maxWidth={videoId !== null ? "50%" : "auto"}
          flexGrow={1}
          sx={{
            overflow: "visible",
            paddingRight: "16px",
            marginRight: "16px",
          }}
        >
          <Box
            sx={{
              overflow: "visible",
              marginRight: "-30px",
            }}
          >
            <VideosContainer
              loading={loading}
              error={error}
              videos={videos}
              onDeleteVideo={handleDeleteVideo}
              onSelectVideo={handleSelectVideo}
              selectedVideoId={videoId}
            />
          </Box>
          {Array.isArray(videos) && videos.length < total && (
            <LoadMoreBtn onClick={loadMore} loading={loading} />
          )}
        </Box>
      )}
      <ConfirmationDialog
        open={deleteVideoIndex !== null}
        onClose={() => setDeleteVideoIndex(null)}
        onConfirm={confirmDeleteVideo}
        title="Delete Video"
        description="Are you sure you want to delete this video?"
        confirmLabel="Delete"
        cancelLabel="Cancel"
      />
    </Stack>
  );
}
